import { TableMode } from '@/models/TableMode';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import { convertResultToRecord } from '../../../utils/games/dragonTiger';
import { DragonTigerResult } from '../../games/dragonTiger';
import { GameState } from '../../games/enums/GameState';
import { GameType } from '../../games/enums/GameType';
import { CMDScInitDragontiger, ICommand } from '../live';
import { CMDDragontiger } from '../live/CMDDragontiger';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitDragontigerHandler extends AbstractHandler {
    _command: CMDScInitDragontiger;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitDragontiger;
    }
    override convertResult(result: CMDDragontiger): DragonTigerResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                DragonCard: result.DragonCard - 1,
                TigerCard: result.TigerCard - 1,
            }
        ) as DragonTigerResult;
        return newResult;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        liveData.GameType = GameType.Dragon;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if (o.BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );
        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;

        const convertedRecord =
            liveData.CurrentState === GameState.Shuffle
                ? []
                : game.OldResult.map(r =>
                      convertResultToRecord(r as DragonTigerResult)
                  );

        // const state = store.getState();
        // const host = getHostById(state, hostId);
        // if (host) {
        //     info.CountDown -= host.DelayResult;
        // }

        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseResult.GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record: convertedRecord,
                    gameType: GameType.Dragon,
                })
            );
        });
    }
}
